import * as UserInterfaces from './user.i';
import { EAccessState } from './user.e';

export class CUserAccess implements UserInterfaces.IUserAccess {
  code = '';
  state = EAccessState.NONE;

  constructor(source?: UserInterfaces.IUserAccess) {
    if (source) {
      Object.assign(this, { code: source.code, state: source.state });
    }
  }
}

export class CAddress implements UserInterfaces.IAddress {
  addr = '';
  postal = '';
  city = '';

  constructor(source?: UserInterfaces.IAddress) {
    if (source) {
      Object.assign(this, { addr: source.addr, postal: source.postal, city: source.city });
    }
  }
}

export class CContact implements UserInterfaces.IContact {
  id = 0;
  civ = '';
  name = '';
  firstName = '';
  birthDate = null;
  role = '';
  mail = '';
  phone = '';
  mobile = '';
  addr = new CAddress();
  cgu = false;
  public get fullName(): string {
    return `${this.firstName || ''} ${this.name}`;
  }
  b_ost = false;

  constructor(source?: UserInterfaces.IContact) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        civ: source.civ,
        name: source.name,
        firstName: source.firstName,
        birthDate: source.birthDate,
        role: source.role,
        mail: source.mail,
        phone: source.phone,
        mobile: source.mobile,
        addr: new CAddress(source.addr),
        cgu: source.cgu,
        b_ost: source.b_ost
      });
    }
  }
}

export class CClient implements UserInterfaces.IClient {
  id = 0;
  name = '';
  type = '';
  addr = new CAddress();
  contacts = [];
  apprenants = [];
  siren = null;
  tva = null;

  constructor(source?: UserInterfaces.IClient) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        name: source.name,
        type: source.type,
        addr: new CAddress(source.addr),
        contacts: source.contacts ? [...source.contacts] : source.contacts,
        apprenants: source.apprenants ? [...source.apprenants] : source.apprenants,
        siren: source.siren,
        tva: source.tva
      });
    }
  }
}

export class CUser implements UserInterfaces.IUser {
  login? = '';
  type? = null;
  userInfo? = new CContact();
  company? = new CClient();
  access? = [];
  password_renew? = true;

  constructor(source?: UserInterfaces.IUser) {
    if (source) {
      Object.assign(this, {
        login: source.login,
        type: source.type,
        userInfo: new CContact(source.userInfo),
        company: source.company,
        access: source.access ? [...source.access] : source.access,
        password_renew: source.password_renew
      });
      if ((source?.company?.contacts || []).length > 0) {
        source?.company?.contacts?.push(this.userInfo);
      }
    }
  }
}
